import { region } from "~~/types";

export default {
	/**
	 * Get current region config
	 */
	getCurrentRegion: (): region => {
		return useRuntimeConfig().public.activeConfig;
	},

	/**
	 * Jump to region
	 *
	 * @param code region code. Ex.: HU, RO
	 */
	changeRegion: (code: string) => {
		window.location.replace(useRuntimeConfig().public.regionDomains[code.toUpperCase()].domain);
	},
};
